import React, {ReactNode} from "react";

import cx from "classnames";

import styles from "./SubHeader.scss";

type SubHeaderProps = {
  children: ReactNode;
  className?: string;
};

export default function SubHeader({
  children,
  className,
}: SubHeaderProps): JSX.Element {
  return (
    <header className={cx(styles.subHeader, className)}>{children}</header>
  );
}
